// @flow
import React from 'react'
import Card from 'reactstrap/lib/Card'
import CardHeader from 'reactstrap/lib/CardHeader'
import CardBody from 'reactstrap/lib/CardBody'
import Collapse from 'reactstrap/lib/Collapse'

// types
type VariablesDebugBlockProps = {
  active?: boolean,
  blacklist?: Array<string>,
  collapseBody?: boolean,
  className?: string,
  collapseObjects?: boolean,
  showOnlyTypes?: boolean,
  title: string,
  variables: any,
}

type VariablesDebugBlockState = {
  bodyCollapsed: boolean,
}

export default class VariablesDebugBlock extends React.Component<VariablesDebugBlockProps, VariablesDebugBlockState> {
  static defaultProps = {
    active: false,
    blacklist: [],
    collapseBody: false,
    className: 'mt-3 text-white bg-dark',
    showOnlyTypes: false,
    collapseObjects: false,
  }

  state = {
    bodyCollapsed: true,
  }

  handleToggleBodyCollapsed = () => {
    if (this.props.collapseBody) {
      this.setState({ bodyCollapsed: !this.state.bodyCollapsed })
    }
  }

  handleToggleCollapsed = (key) => {
    this.setState({ [key]: typeof this.state[key] === 'undefined' ? true : !this.state[key] })
  }

  renderValue = (key, values, prefix = '') => {
    const value = values[key]
    const valueType = typeof value

    if (this.props.blacklist.indexOf(key) !== -1) {
      return null
    }

    if (!value && valueType !== 'boolean') {
      return <p key={key}>{key}: <i>null</i></p>
    }

    if (typeof value === 'function') {
      return <p key={key}>{key}: <i>Function</i></p>
    }

    if (typeof value !== 'object') {
      let valueToDisplay = this.props.showOnlyTypes ? valueType : `${value}`
      if (valueType === 'boolean' && !this.props.showOnlyTypes) {
        valueToDisplay = value ? 'true' : 'false'
      }
      return <p key={key}>{key}: <i>{valueToDisplay}</i></p>
    }

    const collapsedObjects = []

    return (
      <div key={key}>
        <p className='font-weight-bold'>{key}:</p>
        <div className='border border-top-0 border-bottom-0 border-right-0 border-white mx-3 px-1'>
          {Object.keys(value).map((valueKey, index) => {
            if (this.props.collapseObjects && index >= 3) {
              collapsedObjects.push(this.renderValue(valueKey, value, `${prefix}${key}-`))
              if (index === 3) {
                return (
                  <a
                    className='btn btn-link m-0 p-0 pb-2 font-weight-bold text-info'
                    key={valueKey}
                    onClick={() => {
                      this.handleToggleCollapsed(`${prefix}${key}`)
                    }}
                  >
                    {this.state[`${prefix}${key}`] ? 'méně ⯅' : 'více ⯆'}
                  </a>
                )
              }
              return null
            }
            return this.renderValue(valueKey, value, `${prefix}${key}-`)
          })}
          {this.props.collapseObjects &&
          <Collapse isOpen={this.state[`${prefix}${key}`]}>
            {collapsedObjects}
          </Collapse>
          }
        </div>
      </div>
    )
  }

  render = () => {
    if (!this.props.active) {
      return null
    }

    return (
      <Card className={this.props.className}>
        <CardHeader onClick={this.handleToggleBodyCollapsed}>{this.props.title}</CardHeader>
        <Collapse isOpen={this.props.collapseBody && !this.state.bodyCollapsed || !this.props.collapseBody}>
          <CardBody>
            {Object.keys(this.props.variables).map((objectKey) => {
              return this.renderValue(objectKey, this.props.variables)
            })}
          </CardBody>
        </Collapse>
      </Card>
    )
  }
}
